import { IApplicationState } from '../../types/redux';

export function businessAppointmentsIsLoadedSelector(state: IApplicationState): boolean {
  return state.businessAppointments.isLoaded;
}
